import { IOrderEvent } from 'next-common';
import { useEffect, useState } from 'react';
import { queryNextEntityWithToken } from '@utils/serverActions/clientUtility';
import { NEXT_ENTITY, QUERY_VARIANT } from '@common/interfaces';
import { getCachedToken } from '@config/authentication';

export const queryForOrderEvents = async (orderId: string): Promise<IOrderEvent[]> => {
  if (!orderId) return null;
  try {
    const data = await queryNextEntityWithToken(
      NEXT_ENTITY.EVENTS_ON_ORDER,
      getCachedToken(),
      { id: orderId },
      QUERY_VARIANT.FULL,
      { cache: 'no-store' },
      orderId
    );

    //@ts-expect-error
    return data?.events ?? [];
  } catch (error: any) {
    const errorMsg = `Could not get the events for order: "${orderId}"`;
    console.error(errorMsg, error);
    if (typeof error?.statusCode === 'number' && error.statusCode === 200) {
      throw new Error(errorMsg);
    }
  }
};

export const getEvents = (orderId: string, onSuccess: (value: IOrderEvent[]) => Promise<void>): void => {
  queryForOrderEvents(orderId)
    .then((events) => {
      onSuccess(events);
    })
    .catch((err) => {
      const errorMsg = `Could not get the events for order id: "${orderId}"`;
      // tslint:disable-next-line:no-console
      console.error(errorMsg, err);
    });
};

export const useEvents = (orderId?: string): { events: IOrderEvent[]; loading: boolean } => {
  const [events, setEvents] = useState<IOrderEvent[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const onSuccess = async (events?: IOrderEvent[]) => {
    setEvents(events);
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getEvents(orderId, onSuccess);
  }, [orderId]);

  return { events, loading };
};
